// Forest-themed chart wrappers (custom styling, tooltip, grid, colors)
export { LineChart, type LineChartProps } from "./LineChart";
export { BarChart, type BarChartProps } from "./BarChart";
export { PieChart, type PieChartProps } from "./PieChart";
export { useChartColors } from "./useChartColors";

// Forest-themed additional chart types
export { ScatterChart, type ScatterChartProps } from "./ScatterChart";
export { Gauge, type GaugeProps } from "./Gauge";

// Additional chart types (pure re-exports from @mui/x-charts)
export { SparkLineChart } from "@mui/x-charts/SparkLineChart";
export { GaugeContainer, GaugeReferenceArc, GaugeValueArc, GaugeValueText } from "@mui/x-charts/Gauge";

// Composition primitives — for building custom charts
export { ChartContainer } from "@mui/x-charts/ChartContainer";
export { ResponsiveChartContainer } from "@mui/x-charts/ResponsiveChartContainer";
export { ChartsSurface } from "@mui/x-charts/ChartsSurface";
export { ChartsClipPath } from "@mui/x-charts/ChartsClipPath";

// Axis & Grid
export { ChartsAxis } from "@mui/x-charts/ChartsAxis";
export { ChartsXAxis } from "@mui/x-charts/ChartsXAxis";
export { ChartsYAxis } from "@mui/x-charts/ChartsYAxis";
export { ChartsGrid } from "@mui/x-charts/ChartsGrid";
export { ChartsReferenceLine } from "@mui/x-charts/ChartsReferenceLine";

// Legend & Tooltip
export { ChartsLegend } from "@mui/x-charts/ChartsLegend";
export { DefaultChartsLegend } from "@mui/x-charts/ChartsLegend";
export { ChartsTooltip } from "@mui/x-charts/ChartsTooltip";
export { ChartsAxisTooltipContent, ChartsItemTooltipContent, DefaultChartsAxisTooltipContent, DefaultChartsItemTooltipContent } from "@mui/x-charts/ChartsTooltip";
export { ChartsTooltipCell, ChartsTooltipMark, ChartsTooltipPaper, ChartsTooltipRow, ChartsTooltipTable } from "@mui/x-charts/ChartsTooltip";
export { ContinuousColorLegend } from "@mui/x-charts/ChartsLegend";
export { PiecewiseColorLegend } from "@mui/x-charts/ChartsLegend";

// Text
export { ChartsText } from "@mui/x-charts/ChartsText";

// Highlight & Interaction
export { ChartsAxisHighlight } from "@mui/x-charts/ChartsAxisHighlight";
export { ChartsAxisHighlightPath } from "@mui/x-charts/ChartsAxisHighlight";
export { ChartsOnAxisClickHandler } from "@mui/x-charts/ChartsOnAxisClickHandler";
export { ChartsVoronoiHandler } from "@mui/x-charts/ChartsVoronoiHandler";
export { HighlightedProvider } from "@mui/x-charts/context";

// Plot layers — Bar
export { BarPlot } from "@mui/x-charts/BarChart";
export { BarElement, BarElementPath } from "@mui/x-charts/BarChart";
export { BarLabel } from "@mui/x-charts/BarChart";

// Plot layers — Line & Area
export { LinePlot, LineElement, LineElementPath } from "@mui/x-charts/LineChart";
export { AreaPlot, AreaElement, AreaElementPath } from "@mui/x-charts/LineChart";
export { LineHighlightPlot, LineHighlightElement } from "@mui/x-charts/LineChart";
export { MarkPlot, MarkElement } from "@mui/x-charts/LineChart";
export { AnimatedArea, AnimatedLine } from "@mui/x-charts/LineChart";

// Plot layers — Pie
export { PiePlot, PieArc, PieArcPlot, PieArcLabel, PieArcLabelPlot } from "@mui/x-charts/PieChart";

// Plot layers — Scatter
export { ScatterPlot, Scatter } from "@mui/x-charts/ScatterChart";

// Hooks
export { useDrawingArea } from "@mui/x-charts/hooks";
export { useChartId } from "@mui/x-charts/hooks";
export { useSvgRef } from "@mui/x-charts/hooks";
export { useXAxis, useXScale, useXColorScale } from "@mui/x-charts/hooks";
export { useYAxis, useYScale, useYColorScale } from "@mui/x-charts/hooks";
export { useZColorScale } from "@mui/x-charts/hooks";
export { useAxisTooltip } from "@mui/x-charts/ChartsTooltip";
export { useItemTooltip } from "@mui/x-charts/ChartsTooltip";
export { useMouseTracker } from "@mui/x-charts/ChartsTooltip";
export { useHighlighted, useItemHighlighted } from "@mui/x-charts/context";
export { useGaugeState } from "@mui/x-charts/Gauge";

// Color palettes
export {
  blueberryTwilightPalette,
  blueberryTwilightPaletteDark,
  blueberryTwilightPaletteLight,
  cheerfulFiestaPalette,
  cheerfulFiestaPaletteDark,
  cheerfulFiestaPaletteLight,
  mangoFusionPalette,
  mangoFusionPaletteDark,
  mangoFusionPaletteLight,
} from "@mui/x-charts/colorPalettes";

// Utility functions
export { getSeriesToDisplay } from "@mui/x-charts/ChartsLegend";
export { getPieCoordinates } from "@mui/x-charts/PieChart";
